import { EmailValidation } from 'utils/helper';
import { FormattedMessage } from 'react-intl';

const CheckValidation = (value) => {
  const formError = {
    submit: true,
    providerName: {
      error: '',
      errorMessage: <FormattedMessage id="Field is required!" />,
    },
    email: {
      error: '',
      errorMessage: <FormattedMessage id="Field is required!" />,
    },
    mobileNumber: {
      error: '',
      errorMessage: <FormattedMessage id="Field is required!" />,
    },
    state: {
      error: '',
      errorMessage: <FormattedMessage id="Field is required!" />,
    },
    city: {
      error: '',
      errorMessage: <FormattedMessage id="Field is required!" />,
    },
    stateId: {
      error: '',
      errorMessage: <FormattedMessage id="Field is required!" />,
    },
    cityId: {
      error: '',
      errorMessage: <FormattedMessage id="Field is required!" />,
    },
    licence_id: {
      error: '',
      errorMessage: <FormattedMessage id="Field is required!" />,
    },
    licence_Value: {
      error: '',
      errorMessage: <FormattedMessage id="Field is required!" />,
    },
    expire_date: {
      error: '',
      errorMessage: <FormattedMessage id="Field is required!" />,
    },
    phone: {
      error: '',
      errorMessage: <FormattedMessage id="Field is required!" />,
    },
    country_code: {
      error: '',
      errorMessage: <FormattedMessage id="Field is required!" />,
    },
    providerType: {
      error: '',
      errorMessage: <FormattedMessage id="Field is required!" />,
    },
    highestQualification: {
      error: '',
      errorMessage: <FormattedMessage id="Field is required!" />,
    },
    highestQualificationId: {
      error: '',
      errorMessage: <FormattedMessage id="Field is required!" />,
    },
    latitude: {
      error: '',
      errorMessage: <FormattedMessage id="Field is required!" />,
    },
    longitude: {
      error: '',
      errorMessage: <FormattedMessage id="Field is required!" />,
    },
    streetAddress: {
      error: '',
      errorMessage: <FormattedMessage id="Field is required!" />,
    },
    zipCode: {
      error: '',
      errorMessage: <FormattedMessage id="Field is required!" />,
    },
    title: {
      error: '',
      errorMessage: <FormattedMessage id="Field is required!" />,
    },
    titleSlug: {
      error: '',
      errorMessage: <FormattedMessage id="Field is required!" />,
    },
    bio: {
      error: '',
      errorMessage: <FormattedMessage id="Field is required!" />,
    },
    profileId: {
      error: '',
      errorMessage: <FormattedMessage id="Field is required!" />,
    },
    proof_of_address: {
      error: '',
      errorMessage: <FormattedMessage id="Field is required!" />,
    },
    proof_of_address_id: {
      error: '',
      errorMessage: <FormattedMessage id="Field is required!" />,
    },
    licenceNumber: {
      error: '',
      errorMessage: <FormattedMessage id="Field is required!" />,
    },
    startTime: {
      error: '',
      errorMessage: <FormattedMessage id="Field is required!" />,
    },
    endTime: {
      error: '',
      errorMessage: <FormattedMessage id="Field is required!" />,
    },
    phoneNumber: {
      error: '',
      errorMessage: <FormattedMessage id="Field is required!" />,
    },
    diagnosis_finding: {
      error: '',
      errorMessage: <FormattedMessage id="Field is required!" />,
    },
    adviceText: {
      error: '',
      errorMessage: <FormattedMessage id="Field is required!" />,
    },
    medication_name: {
      error: '',
      errorMessage: <FormattedMessage id="Field is required!" />,
    },
    medicine_form: {
      error: '',
      errorMessage: <FormattedMessage id="Field is required!" />,
    },
    dosage: {
      error: '',
      errorMessage: <FormattedMessage id="Field is required!" />,
    },
    duration: {
      error: '',
      errorMessage: <FormattedMessage id="Field is required!" />,
    },
    reason: {
      error: '',
      errorMessage: <FormattedMessage id="Field is required!" />,
    },
  };

  const emptyKeys = [];
  for (let key in value) {
    emptyKeys.push(key);
  }

  for (let i = 0; i < emptyKeys.length; i++) {
    if (!value[emptyKeys[i]]) {
      formError[emptyKeys[i]].error = true;
      formError.submit = false;
    }

    if (
      value[emptyKeys[i]] &&
      emptyKeys[i] === 'email' &&
      !EmailValidation(value[emptyKeys[i]])
    ) {
      formError[emptyKeys[i]].error = true;
      formError.submit = false;
      formError[emptyKeys[i]].errorMessage = (
        <FormattedMessage id="Please Enter Valid Email!" />
      );
    }
  }
  return formError;
};

export default CheckValidation;
